import React from 'react';
import { Tabs, TabList, Tab } from '@chakra-ui/react';
import { projectFilterOptions } from '../../utils/layoutConfig';

const ProjectFilter = ({ filter, setFilters }) => {
	const [filterlist, _] = React.useState(projectFilterOptions);

	function onChangeHandler(index) {
		const newFilter = { ...filter };
		newFilter['stageFilter'] = filterlist[index] ? filterlist[index].value : 'all';
		setFilters(newFilter);
	}
	return (
		<Tabs onChange={onChangeHandler} flexBasis="100%" mb={5} mt={3} border="0px solid">
			<TabList border="0px solid">
				{filterlist &&
					filterlist.map((filter, index) => (
						<Tab
							key={index}
							_selected={{ color: 'blue.400', borderColor: 'yellow.400', borderBottomWidth: '4px' }}
							fontSize={'md'}
							borderBottomWidth="4px"
						>
							{filter.name}
						</Tab>
					))}
			</TabList>
		</Tabs>
	);
};

export default ProjectFilter;
